<mat-toolbar *ngIf="show" class="new-version-toolbar">
    <mat-toolbar-row class="new-version-toolbar-row">
        <span class="new-version-toolbar-text" i18n="A new version of the app is available">A new version of the app is available</span>
        <a class="new-version-toolbar-link" [href]="updateUrl" i18n="New version button|Refresh" mat-flat-button color="primary">Refresh</a>
    </mat-toolbar-row>
</mat-toolbar>
